import Front from '../Images/front.svg'
import GreenFront from '../Images/greenFrontSedan.svg'
import RedFront from '../Images/redFrontSedan.svg'
import FrontRight from '../Images/front-right.svg'
import GreenFrontRight from '../Images/greenFrontRightSedan.svg'
import RedFrontRight from '../Images/redFrontRightSedan.svg'
import Right from '../Images/right.svg'
import GreenRight from '../Images/greenRightSedan.svg'
import RedRight from '../Images/redRightSedan.svg'
import RearRight from '../Images/rear-right.svg'
import GreenRearRight from '../Images/greenRearRightSedan.svg'
import RedRearRight from '../Images/redRearRightSedan.svg'
import Rear from '../Images/rear.svg'
import GreenRear from '../Images/greenRearSedan.svg'
import RedRear from '../Images/redRearSedan.svg'
import RearLeft from '../Images/rear-left.svg'
import GreenRearLeft from '../Images/greenRearLeftSedan.svg'
import RedRearLeft from '../Images/redRearLeftSedan.svg'
import Left from '../Images/left.svg'
import GreenLeft from '../Images/greenLeftSedan.svg'
import RedLeft from '../Images/redLeftSedan.svg'
import FrontLeft from '../Images/front-left.svg'
import GreenFrontLeft from '../Images/greenFrontLeftSedan.svg'
import RedFrontLeft from '../Images/redFrontLeftSedan.svg'
import WindshieldInside from '../Images/windshield-inside.svg'
import WindshieldOutside from '../Images/windshield-out.svg'
import SunroofOutside from '../Images/sidebar-sunroof-outside.png'
import EngineNumber from '../Images/engine-number.svg'
import ChassisNumber from '../Images/chassis-number.svg'
import OdoMeter from '../Images/odo-meter.svg'
import RcFront from '../Images/rc-front.svg'
import RcBack from '../Images/rc-back.svg'
import SedanFront from '../Images/sedan-front.svg'
import SedanFrontLeft from '../Images/sedan-front-left.svg'
import SedanFrontRight from '../Images/sedan-front-right.svg'
import SedanLeft from '../Images/sedan-left.svg'
import SedanRight from '../Images/sedan-right.svg'
import SedanRearRight from '../Images/sedan-rear-right.svg'
import SedanRear from '../Images/sedan-rear.svg'
import SedanRearLeft from '../Images/sedan-rear-left.svg'
import SedanWindshieldInside from '../Images/sedan-windshield-inside.svg'
import SedanWindshieldOutside from '../Images/sedan-windshield-outside.svg'
import SedanVehicleEngine from '../Images/vehicle-engine-no.svg'
import SedanVehicleChassis from '../Images/vehicle-chassis-no.svg'
import SedanSpeedometer from '../Images/sedan-speedometer.svg'
import SedanRCBookFront from '../Images/vehicle-rc-book-front.svg'
import SedanRCBookBack from '../Images/vehicle-rc-book-back.svg'

/* Split Car Images Import */
//* Right Front
import SPRightFront from '../Images/Split/SPRightFront.svg';
import SplitRightFront from '../Images/Split/split-right-front.svg'
import GreenSplitRightFront from '../Images/Split/green-split-right-front.svg'
import RedSplitRightFront from '../Images/Split/red-split-right-front.svg'

//? Right Rear
import SPRightRear from '../Images/Split/SPRightRear.svg';
import SplitRightRear from '../Images/Split/split-right-rear.svg'
import GreenSplitRightRear from '../Images/Split/green-split-right-rear.svg'
import RedSplitRightRear from '../Images/Split/red-split-right-rear.svg'

//* Left Front
import SPLeftFront from '../Images/Split/SPLeftFront.svg';
import SplitLeftFront from '../Images/Split/split-left-front.svg'
import GreenSplitLeftFront from '../Images/Split/green-split-left-front.svg'
import RedSplitLeftFront from '../Images/Split/red-split-left-front.svg'

//? Left Rear
import SPLeftRear from '../Images/Split/SPLeftRear.svg';
import SplitLeftRear from '../Images/Split/split-left-rear.svg'
import GreenSplitLeftRear from '../Images/Split/green-split-left-rear.svg'
import RedSplitLeftRear from '../Images/Split/red-split-left-rear.svg'

// TODO: Add actual sunroof image imports when available
import SunroofInside from '../Images/sidebar-sunroof-inside.png'
import SedanSunroofInside from '../Images/sunroof-interior.svg'
import SedanSunroofOutside from '../Images/sunroof-exterior.svg'


const lat = "19.1624"
const lon = "72.9376"

const sunroofCar = [
    {
        key: 1,
        isCar: false,
        id: "front",
        stencil: SedanFront,
        greenStencil: GreenFront,
        redStencil: RedFront,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: true,
        isUpload: false,
        imgId: "Front",
        ImageSrc: Front,
        name: "Front",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "front-right",
        isCar: false,
        isUploadImg: null,
        isUploadBlob: null,
        key: 2,
        stencil: SedanFrontRight,
        greenStencil: GreenFrontRight,
        redStencil: RedFrontRight,
        isActive: false,
        isUpload: false,
        imgId: "Front_Right",
        ImageSrc: FrontRight,
        name: "Front-right",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "sp-right-front",
        isCar: false,
        key: 3,
        stencil: SplitRightFront,
        greenStencil: GreenSplitRightFront,
        redStencil: RedSplitRightFront,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Partial_Front_Right",
        ImageSrc: SPRightFront,
        name: "SP-Right-Front",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "sp-right-rear",
        isCar: false,
        key: 4,
        stencil: SplitRightRear,
        greenStencil: GreenSplitRightRear,
        redStencil: RedSplitRightRear,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Partial_Rear_Right",
        ImageSrc: SPRightRear,
        name: "SP-Right-Rear",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "rear-right",
        key: 5,
        isCar: false,
        stencil: SedanRearRight,
        greenStencil: GreenRearRight,
        redStencil: RedRearRight,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Rear_Right",
        ImageSrc: RearRight,
        name: "Rear-right",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "rear",
        key: 6,
        isCar: false,
        stencil: SedanRear,
        greenStencil: GreenRear,
        redStencil: RedRear,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Rear",
        ImageSrc: Rear,
        name: "Rear",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "rear-left",
        key: 7,
        isCar: false,
        stencil: SedanRearLeft,
        greenStencil: GreenRearLeft,
        redStencil: RedRearLeft,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Rear_Left",
        ImageSrc: RearLeft,
        name: "Rear-left",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "sp-left-rear",
        stencil: SplitLeftRear,
        greenStencil: GreenSplitLeftRear,
        redStencil: RedSplitLeftRear,
        key: 8,
        isCar: false,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Partial_Rear_Left",
        ImageSrc: SPLeftRear,
        name: "SP-Left-Back",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "sp-left-front",
        stencil: SplitLeftFront,
        greenStencil: GreenSplitLeftFront,
        redStencil: RedSplitLeftFront,
        key: 9,
        isCar: false,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Partial_Front_Left",
        ImageSrc: SPLeftFront,
        name: "SP-Left-Front",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "front-left",
        key: 10,
        isCar: false,
        stencil: SedanFrontLeft,
        greenStencil: GreenFrontLeft,
        redStencil: RedFrontLeft,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Front_Left",
        ImageSrc: FrontLeft,
        name: "Front-left",
        toValidate: true,
        UploadFile: null,
        message: "",
        latitude: lat,
        longitude: lon
    },

    {
        id: "windshield-outside",
        key: 11,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanWindshieldOutside,
        isActive: false,
        isUpload: false,
        imgId: "Windshield_Outside_Side",
        ImageSrc: WindshieldOutside,
        name: "Windshield from-outside",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    {
        id: "windshield-inside",
        key: 12,
        isCar: true,
        stencil: SedanWindshieldInside,
        isUploadImg: null,
        isUploadBlob: null,
        isActive: false,
        isUpload: false,
        imgId: "Windshield_Inside_Side",
        ImageSrc: WindshieldInside,
        name: "Windshield from-inside",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    // NEW: Sunroof images
    {
        id: "sunroof-inside",
        key: 13,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanSunroofInside, // TODO: Replace with actual sunroof stencil
        isActive: false,
        isUpload: false,
        imgId: "Sunroof_Inside",
        ImageSrc: SunroofInside, // TODO: Replace with actual sunroof image
        name: "Sunroof Interior",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    {
        id: "sunroof-outside",
        key: 14,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanSunroofOutside, // TODO: Replace with actual sunroof stencil
        isActive: false,
        isUpload: false,
        imgId: "Sunroof_Outside",
        ImageSrc: SunroofOutside, // TODO: Replace with actual sunroof image
        name: "Sunroof Exterior",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    {
        id: "engine-no",
        key: 15,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanVehicleEngine,
        isActive: false,
        isUpload: false,
        imgId: "Engine_No",
        ImageSrc: EngineNumber,
        name: "Engine No.",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    {
        id: "chassis-no",
        key: 16,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanVehicleChassis,
        redStencil: SedanVehicleChassis,
        greenStencil: SedanVehicleChassis,
        isActive: false,
        isUpload: false,
        imgId: "Chassis_No",
        ImageSrc: ChassisNumber,
        name: "Chassis No.",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

    {
        id: "odo-meter",
        key: 17,
        isCar: true,
        isUploadImg: null,
        isUploadBlob: null,
        stencil: SedanSpeedometer,
        redStencil: SedanSpeedometer,
        greenStencil: SedanSpeedometer,
        isActive: false,
        isUpload: false,
        imgId: "ODO_Meter",
        ImageSrc: OdoMeter,
        name: "ODO Meter",
        toValidate: false,
        UploadFile: null,
        latitude: lat,
        longitude: lon
    },

]

export default sunroofCar;